import router from '@/router';

export default () => {
  const handlers: { [k: string]: (options: object) => void } = {
    async showAnnounceModal({ eventId }: any) {
      try {
        await router.push({ name: 'EventAnnounceModal', params: { eventId } });
      } catch (e) {
        console.error('error navigating: ', e);
      }
    },
    async showOfferSheetsModal({ offerSheetsId }: any) {
      try {
        await router.push({ name: 'OfferSheet', params: { offerSheetsId } });
      } catch (e) {
        console.error('error navigating: ', e);
      }
    },
    async showArtistSettlementSheet({ eventArtistId, settlementId }: any) {
      try {
        await router.push({ name: 'ArtistSettlementSheet', params: { eventArtistId, settlementId } });
      } catch (e) {
        console.error('error navigating: ', e);
      }
    },
  };

  document.addEventListener('vue-action', e => {
    const e1 = e as CustomEvent;

    if (!e1.detail) {
      return;
    }

    const handler = handlers[e1.detail['action']];
    if (handler) {
      handler(e1.detail);
    }
  });
};
